<template>
  <div>
    <div class="greenBar"></div>
    <el-container class="index-con">
      <el-aside :class="{left_nav_hide:showclass}">
        <leftnav @childsend="rev"></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-header class="index-header">
          <navcon></navcon>
        </el-header>
        <el-main clss="index-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
  // 导入组件
  import navcon from '../components/navcon.vue'
  import leftnav from '../components/leftnav.vue'
  export default {
    name: 'index',
    data() {
      return {
        showclass: false,
        showtype: false
      }
    },
    // 注册组件
    components: {
      navcon,
      leftnav
    },
    methods: {
      rev(val) {
        // val就是子组件发送的数据
        this.showclass = val
      }
    },

    beforeUpdate() {},
    // 挂载前Status(里面是Action)
    beforeMount() {}
  }

</script>
<style>
  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }

  .greenBar {
    height: 4px;
    width: 100%;
    background: #00b8c2;
    position: fixed;
    z-index: 10000;
  }

</style>



// WEBPACK FOOTER //
// src/views/index.vue